import { $user } from "./UserFactory";
import { CrudRequest, RequestOptions } from "@crud/core";
import { chooseFile } from "@crud/web";
import { getFingerprintHeaders, refreshAccessToken } from "./apiUtils";
import appConfig from "./../config/appConfig";


export class CrudFactory extends CrudRequest {
  baseUrl = appConfig.API_URL;
  // baseUrl = "https://immosnapp.teamjft.com";
  // baseUrl = "http://fb3d69fe9cef.ngrok.io";

  getUrl = (...segments) =>
    segments.reduce((url, segment) => url + segment, this.baseUrl);

  constructor() {
    super();
    this.config(chooseFile);
  }

  async get<Request = any, Response = any>(
    url: string,
    data: any = {},
    requestOptions: RequestInit = {}
  ): Promise<ResponseType<Response>> {
    return this.send({
      method: "GET",
      url,
      data,
      ...requestOptions,
    });
  }

  async post<Request = any, Response = any>(
    url: string,
    data: any = {},
    requestOptions: RequestOptions = {}
  ): Promise<ResponseType<Response>> {
    return this.send({
      method: "POST",
      url,
      data,
      ...requestOptions,
    });
  }

  async put<Request = any, Response = any>(
    url: string,
    data: any = {},
    requestOptions: RequestOptions = {}
  ): Promise<ResponseType<Response>> {
    return this.send({
      method: "PUT",
      url,
      data,
      ...requestOptions,
    });
  }

  async delete<Request = any, Response = any>(
    url: string,
    data: any = {},
    requestOptions: RequestOptions = {}
  ): Promise<ResponseType<Response>> {
    return this.send({
      method: "DELETE",
      url,
      data,
      ...requestOptions,
    });
  }

  async send(requestOptions: RequestOptions = {}): Promise<ResponseType<any>> {
    const { url, data, method, notify = true } = requestOptions;

    const options: RequestInit = {
      ...requestOptions.ajaxOptions,
      method,
    };

    let fullUrl;

    options.headers = {
      ...options.headers,
      Accept: "application/json",
      Authorization: `jwt ${$user.getToken()}`,
      ...getFingerprintHeaders(),
    };
    fullUrl = this.getUrl(url);

    if (options.method === "GET") {
      let queryString = new URLSearchParams(data);
      fullUrl += `?${queryString}`;
    } else if (!(data instanceof FormData)) {
      options.body = JSON.stringify(data);
      options.headers["Content-Type"] = "application/json";
    } else {
      options.body = data;
    }

    let res = {
      // data: [],
      message: "",
      status: null,
    };

    try {
      const response = await fetch(fullUrl, options);
      if (response.status === 200) {
        res = await response.json();
        const { status, message } = res;
        // A 2FA challenge is status:false on purpose. Do not toast it as a
        // failed login, and do not throw it away before the login page can
        // open the code screen.
        if (res && res.requires2FA) {
          return res;
        }
        if (options.method !== "GET" && notify && message) {
          this.notify({
            message,
            type: status ? "success" : "error",
        action:null

          });
        }
      } else {
        // On an expired/invalid token, transparently refresh once and retry the
        // request (skip auth endpoints and already-retried requests to avoid loops).
        if (
          response.status === 401 &&
          !requestOptions._retry &&
          typeof url === "string" &&
          url.indexOf("/auth/") === -1
        ) {
          const newToken = await refreshAccessToken();
          if (newToken) {
            return this.send({ ...requestOptions, _retry: true });
          }
        }
        if (response.status === 400 || response.status === 401) {
          res = await response.json();
          const { status, message } = res;
          return { status, message }
        }
        if (response.status === 413) {
          throw new Error(
            "File is too large for the server. Please use a smaller file."
          );
        }
        else {
          let message = `${response.status} : ${response.statusText}`;
          try {
            const body = await response.json();
            if (body && body.message) message = body.message;
          } catch (_) { /* HTML / empty gateway body */ }
          throw new Error(message);
        }
      }
    } catch (e) {
      this.notify({
        message: e.message,
        type: "error",
        action:null
      });
      throw e;
    }

    const { status } = res;
    if (!status) throw res;

    return res;
  }
}

export const $crud = new CrudFactory();
